import { makeMap } from "tinymce";

export interface GeoMonUserJson {
	Created: string;
	CreatedBy: string;
	Modified: string;
	ModifiedBy: string;
	CustomerId: string;
	DealerId: string;
	Disabled: boolean;
	IsManager: boolean;
	DisplayName: string;
	IsAdmin: boolean;
	IsService: string;
	Id: string;
	Dealer: any;
	Customer: any;
	IsRenter: string;
}

export function fixFullHeight() {
	let fixedHeightVal = $(window).height() - $(".navbar").outerHeight();
	$('.full_height_fixed').height(fixedHeightVal);
}

export enum UserRole {
	Admin,
	Service,
	Dealer,
	Customer,
	Manager,
	Renter
}

export function isAdmin(userRoles: Array<UserRole>) {
	if (userRoles)
		return (userRoles.includes(UserRole.Admin));
	else
		return false;
}

export function isService(userRoles: Array<UserRole>) {
	if (userRoles)
		return (userRoles.includes(UserRole.Service));
	else
		return false;
}

export function isDealer(userRoles: Array<UserRole>) {
	if (userRoles)
		return (userRoles.includes(UserRole.Dealer));
	else
		return false;
}

export function isCustomer(userRoles: Array<UserRole>) {
	if (userRoles)
		return (userRoles.includes(UserRole.Customer));
	else
		return false;
}

export function isRenter(userRoles: Array<UserRole>) {
	if (userRoles)
		return (userRoles.includes(UserRole.Renter));
	else
		return false;
}
export function isManager(userRoles: Array<UserRole>) {
	if (userRoles)
		return (userRoles.includes(UserRole.Manager));
	else
		return false;
}


// dd/mm/yyyy HH:mm
export function formattedDateTime(z: Date) {
	return z.getDate() + "/" + (z.getMonth() + 1) + "/" + z.getFullYear() + " " + z.getHours() + ":" + z.getMinutes();
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func: () => void, wait: number, immediate: boolean): () => void {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export function fixGuidFilterOdata4(data, type) {
	var result = kendo.data.transports["odata-v4"].parameterMap(data, type);

	if (result.$filter) {
		// Remove the single quotation marks around the GUID (OData v4).
		// http://www.telerik.com/forums/guids-in-filters
		result.$filter = result.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
			return x.substring(1, x.length - 1);
		});
	}
	return result;
}

export function isGuid(str) {
	var regexGuid = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/ig;
	return regexGuid.test(str);
}

export function fixODatav4Response(response) {
	var data = response.value ? response.value : [response];
	for (var idx = 0; idx < data.length; idx++) {
		data[idx].etag = data[idx]["@odata.etag"];
		// rimozione etag perchè causa un errore imprevisto durante il cancelChanges(Model) !?!
		delete data[idx]["@odata.etag"];
		delete data[idx]["@odata.context"];
	}
	return response;
}


// WEBPACK FOOTER //
// ./js/shared.ts